import { useSelector } from 'react-redux';

import { advancedFiltersCountSelector } from 'shared/store/data/filters/selectors/smart/advancedFiltersCountSelector';

export function useAvailableFiltersCount(): number {
  const advancedFiltersCount = useSelector(advancedFiltersCountSelector);

  return advancedFiltersCount;
}
